import { type MoneyData } from "../../utils/money";
import { getUserStatsInfo } from "../../utils/user-stats-info";
import { getCurrentLanguageCode } from "../../utils/configuration";
import { client } from "../client";

export declare interface CalculateNotaryEstimationInput {
	district: string;
	name: string;
	email: string;
	phone: string;
	value: MoneyData;
	reward: MoneyData;
	rewardTax: MoneyData;
	multipleProperties?: boolean | null;
}

export async function calculateNotaryEstimation(input: CalculateNotaryEstimationInput): Promise<string> {
	const json: any = {
		...input,
		...getUserStatsInfo(),
		languageCode: getCurrentLanguageCode(),
		url: window.document.location.href,
	};

	return await client
		.post("/_api_v0/notary-estimation/calculate/v1", {
			json,
		})
		.json()
		.then((data: any) => data.id);
}
